
import apiErrMixin from "@/mixins/api-err"
import { scrollToFirstError } from "@/utils/error"
import { useCaptcha } from "@/utils/captcha"

export default apiErrMixin.extend({
  data: () => ({
    model: {} as Record<string, string>,
    isLoading: false,
    isDone: false,
  }),

  watch: {
    model: {
      deep: true,
      handler () {
        this.$set(this.apiErr, "message", "")
      },
    },
  },

  methods: {
    async onSubmit () {
      const { validationObserver } = this.$refs
      if (!validationObserver) return

      const isValid = await (validationObserver as any).validate()
      if (!isValid) {
        scrollToFirstError()
        return
      }

      useCaptcha(async (token) => {
        this.resetApiErr()
        this.isLoading = true

        const [, err] = await this.$api.media.submitFeedback({
          ...this.model,
          captcha: token,
        })

        if (err) {
          this.apiErr = err
          await this.$nextTick()
          scrollToFirstError()
        } else {
          this.isDone = true
        }

        this.isLoading = false
      })
    },
  },
})
